import React, { useState, useEffect } from 'react';
import Layout from '../../component/layout/Layout';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import firebaseConfig from '../firebase/firebaseConfig';

// Initialize Firebase only if not already initialized
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

const AboutPage = () => {
    const [aboutUsData, setAboutUsData] = useState(null); // State to store fetched data
    const [loading, setLoading] = useState(true); // State to handle loading
    const [error, setError] = useState(null); // State to handle errors
    const [activeSlide, setActiveSlide] = useState(0);

    useEffect(() => {
        const fetchAboutUsData = async () => {
            try {
                const snapshot = await db.collection("aboutUspage").get();

                if (!snapshot.empty) {
                    const doc = snapshot.docs[0];
                    setAboutUsData(doc.data());
                } else {
                    setError("No data found.");
                }
            } catch (err) {
                setError("Error fetching data.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAboutUsData();
    }, []);

    const handleSlideChange = (index) => {
        setActiveSlide(index);
    };

    if (loading) {
        return <Layout><p>Loading...</p></Layout>;
    }

    if (error) {
        return <Layout><p>{error}</p></Layout>;
    }

    return (
        <Layout>
            <section id="hero">
                <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-interval="5000" data-bs-ride="carousel">
                    <ol className="carousel-indicators" id="hero-carousel-indicators">
                        <li
                            data-bs-target="#heroCarousel"
                            data-bs-slide-to="0"
                            className={activeSlide === 0 ? "active" : ""}
                            onClick={() => handleSlideChange(0)}
                        ></li>
                    </ol>
                    <div className="carousel-inner" role="listbox">
                        <div className={`carousel-item ${activeSlide === 0 ? "active" : ""}`} style={{ backgroundImage: "url(/Carousel/about-us3.jpeg)" }}>
                            <div className="carousel-container">
                                <div className="container">
                                    <div className="text" id="text">
                                        <h2 className="animate__animated animate__fadeInDown" data-aos="fade-down">{aboutUsData.title}</h2>
                                        <p className="animate__animated animate__fadeInUp" data-aos="fade-up">
                                            {aboutUsData.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <div className="container">
                <div className="row align-items-center py-5">
                    <div className="section-title text-center">
                        <h1 style={{ textTransform: 'capitalize' }}>{aboutUsData.title}</h1>
                    </div>
                    <div className="col" style={{textAlign: 'justify'}}>
                        {aboutUsData.additionalInfo.map((info, index) => (
                            <p key={index}>{info}</p>
                        ))}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AboutPage;
